<template>
    <v-navigation-drawer
            permanent
            width="21%"
            style="margin-left: 60px; font-family: Roboto, sans-serif; z-index: 1; padding-top: 90px !important;"
            fixed
            left
            floating
            class="transparent pl-3 pr-2 pb-3"
    >
        <attention-summary :event="summaryEvent" />

    </v-navigation-drawer>
</template>

<script>
    import AttentionSummary from '../AttentionSummary'
    import {mapMutations, mapState} from 'vuex'

    export default{
        components: {AttentionSummary},
        data(){
            return {
                evt: null
            }
        },
        methods: {
            ...mapMutations('clientAttention', [
                'showAttentionSummaryDrawer',
                'hideAttentionSummaryDrawer',
            ]),
          showOrHideDrawer(){
              const vm = this
              if(!vm.isMobile && !vm.isMD){
                vm.showAttentionSummaryDrawer()
              }else{
                vm.hideAttentionSummaryDrawer()
              }
          }
        },
        computed:{
            ...mapState('clientAttention', {
                summaryEvent: state => state.summaryEvent,
                drawer: state => state.attentionSummaryDrawer
            }),
            model: {
                get(){
                    return this.drawer
                },
                set(val){
                    if(val){
                        this.showAttentionSummaryDrawer()
                    }else{
                        this.hideAttentionSummaryDrawer()
                    }
                }
            }
        },
        watch:{
            isMobile(){
              this.showOrHideDrawer()
            },
            isMD(){
              this.showOrHideDrawer()
            }
        }
    }
</script>

<style scoped>
    .attention-summary{

    }
</style>
